import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import DataTable from "../../components/Table/DataTable.jsx";
import Actions from "./additionFields/Actions.jsx";
import Alert from "../../utils/Alert.js";
import { getAllTicketsService } from "../../services/ticketsServices.js";
import Status from "./additionFields/Status.jsx";
import Priority from "./additionFields/Priority.jsx";

const Tickets = () => {
  const [tickets, setTickets] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();  

  useEffect(() => {  
      if (location.state?.refresh) {
        handleGetAllTickets();
      }  
  }, [location.state]);  


  const ticketsCols = [
    {
      field: "code",
      text: "کد تیکت",
    },
    {
      field: "subject",
      text: "عنوان تیکت",
    },
    // {
    //   field: null,
    //   text: "سرویس تیکت",
    //   element: (rowData) => (
    //     <span className={!rowData.service ? "text-red-500" : ""}>
    //       {rowData.service || "ندارد"}
    //     </span>
    //   ),
    // },
    // {
    //   field: "",
    //   text: "درجه‌ی اهمیت",
    //   element: (rowData) => <Priority rowData={rowData} />,
    // },
    {
      field: null,
      text: "وضعیت",
      element: (rowData) => <Status rowData={rowData} />,
    },
    {
      field: null,
      text: "عملیات‌ها",
      element: (rowData) => <Actions rowData={rowData} />,
    },
  ];

  const handleGetAllTickets = async () => {
    try {
      setIsLoading(true);
      const response = await getAllTicketsService();
      if (response.status === 200) {
        setTickets(response.data);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleGetAllTickets();
  }, []);

  return (
    <DataTable
      tableCols={ticketsCols}
      tableData={tickets}
      itemsCount={10}
      title="تیکت‌ها"
      searchField="subject"
      searchTitle="عنوان تیکت"
      isLoading={isLoading}
    >
      <Link
        to="/tickets/add-ticket"
        className="bg-primary px-3 py-1 rounded-lg 
            text-white"
      >
        افزودن اعلان
      </Link>
      <Outlet
        context={{
          setTickets,
        }}
      />
    </DataTable>
  );
};

export default Tickets;
